export interface DonationCardGeneralInfoVM {
  donationId: number;
  donationAmount: number;
  donationDate: string;
  donorId: number;
  donorTypeId: number;
  donorTypeName: string;
  donorName: string;
  campaignName: string;
  depositDate?: string;
  refundAmount: number;
  conversionDate?: string;
  isPledged: boolean;
  batchName: string;
  source: string;
  sourceId: number;
  contributionType: string;
  contributionTypeId: number;
  eventCode: string;
  eventId: number;
  transactionId: string;
  enteredBy: string;
  fundCode?: string; 
  fundCodeId?: number;
  isDntHasRdesOrReAttrSplits: boolean;
}

export interface DonorGeneralInformationVM {
  firstName: string;
  lastName: string;
  prefix?: string;
  suffix?: string;
  organization?: string;
}

export interface DonorContactDetails {
  addresses?: Address[];
  phones?: {
    donorPhoneNumberId: number;
    phoneTypeId: number;
    phoneType: string;
    donorPhoneNumber: string;
  }[];
  emails?: {
    donorEmailId: number;
    email: string;
    emailTypeId: number;
    emailType: string;
  }[];

}

export interface Address {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  isPrimary?: boolean;
  isPrimaryString?: string;
  addressType?: string; 
  addressTypeId?: number;
}

export interface DonorRelationship {
  donorId: number; 
  relatedDonorId: number; 
  relationshipTypeId: number; 
}

export interface DonorRelationshipType {
  text: string; 
  value: string; 
}

export interface DonorRelationshipResponse {
  relationship: DonorRelationship | null; 
  relationshipTypes: DonorRelationshipType[]; 
}

export interface DonationFecComplianceVM {
  fecLineNumber: string;
  fecDescription: string;
  isMemo: boolean;
  memoText?: string;
  fecLineNumbers: SelectListItem[];
}

export interface ParentDonationViewModel {
  // Parent donation fields
  parentDonationType: string;
  parentDonationName: string;
  parentDonationNumber: number;

  // Child donation fields
  parentDonorId?: number;
  parentDonationId?: number;
  parentDonor?: string;
  checkNumber?: string;

  isMasterDonation?: boolean;
  transferTypeId?: number;
}

export interface DonationFundraiserViewModel {
  fundraiserId: number;
  bundlerId: string;
  name: string;
}

export interface ParentDonationModel {
  transferTypes?: SelectListItem[];
  parentDonationType: string;
  parentDonationTypeId: number;
  parentDonorId?: number;
  parentDonationId?: number;
  parentDonor?: string;
  checkNumber?: string;
  paclimitNotAffected?: boolean;
}

export interface ParentDonationSearchModel {
  text: string; 
  value: string; 
  checkNumber: string;
}

export interface AddDonationFlagAndAssignToDonationViewModel {
  donationId: number;
  title: string;
  description: string;
}

export interface DonationLetterViewModel {
  letterType: string;
  dateSent: string;
  responseReceivedDate: string;
}

export interface DonationNotesViewModel {
  isThankYouNoteSent: boolean;
  thankYouNoteSentDate?: string;
  customNote?: string;
}

export interface DonationFlagViewModel {
  donationFlagId: number;
  name: string;
  description: string;
}

export interface DonationCardDonationsGridRow {
  splitId: number;
  donationId: number;
  donorId: number;
  originatingDonationId?: number;
  campaignName: string;
  donorName: string;
  correctiveActionTypeId?: number;
  type: string;
  donationDate: string;
  amount?: number;
  refundAmount?: number;
  fundCode: string;
  fundcodeId: number;
  editDate?: string;
}

export interface ChildRow {
  name: string;
  relationship: string;
  amount: number;
  remainingAmount: number;
}

export interface FundcodesHistory {
  donorId: number;
  donorName: string;
  fundcode: string;
  amount: number;
  remainingAmount: number;
  fundCodeId: number;
  campaignId: number;
  isChild: boolean; 
  relationshipType: string;
  houseHold: boolean; 
  campaignName: string;
  noLimit: boolean;
}

export interface DropdownOption {
  text: string;
  value: any;
}

export class EditDonationGeneralInfoViewModel {
  donationId!: number;
  splitId!: number;
  donationDate?: Date; 
  conversionDate?: Date;
  donationAmount!: number;
  refundAmount!: number;
  eventId!: number;
  contributionSourceId?: number;
  contributionTypeId?: number;
  pledged!: boolean;
  fundCode?: string; // Add fundCode property
  fundCodeId?: number; // Add fundCodeId property
}

export class DonationGeneralInfoLookupViewModel {
  donorSources!: SelectListItem[];
  contributionTypes!: SelectListItem[];
}

export class SelectListItem {
  text!: string;
  value!: number;
}

export class FECComplianceUpdateViewModel {
  fecLineNumber?: string;
  fecLineNumberId?: number;
  fecDescription!: string;
  memoText?: string;
  isMemo!: boolean;
}

export interface AttributionModel {
  DonorId: number;
  FecLineNumberId: number;
  FundCodeId: number;
  Amount: number;
  FecDesc: string;
  AdjustmentDate: Date;
  Notes: string;
}

export interface DonationComplianceAttributionModel {
  DonationId: number;
  SplitId: number;
  RefundAmount?: number;
  SelectedDonationRespActionTypeId: number;
  AttributedDnrList: AttributionModel[];
}

export interface LetterCmmVm {
  letterTypes: SelectListItem[];
  oldLetterTypeId?: number;
  letterTypeId?: number;
  letterType?: string;
  dateSent?: Date;
  isResponseReceived?: boolean;
  responseReceivedDate?: Date;
  returnLetterTypes?: SelectListItem[];
  returnLetterTypeId?: number;
  refundAmount?: number;
  complianceLetterTypeRefundAmount?: number;
  otherComplianceLetterTypeRefundAmount?: number;
  donationAmount?: number;
  parentDonorName?: string;
  parentDonorPermissibleFunds?: number;
  fecLineNumbers?: SelectListItem[];
  fecLineNumberId?: number;
  fecDescription?: string;
  attributedDonors?: any[]; // Replace with appropriate type if available
}

export interface DonationComplianceLetterViewModel {
  letterTypes: SelectListItem[];
  fecLineNumbers: SelectListItem[];
  addLetterCmmVm: LetterCmmVm;
  selectedLetterCmmVm: LetterCmmVm[];
}

export enum DntComplianceLetterType {
  OverLimit = '1',
  Redesignation = '2',
  PACMultiRedesignation = '3',
  PACNonRedesignation = '4',
  PresumptiveReattribution = '5',
  DebtRetirement = '6',
  OverLimitwithDebt = '7',
  BusinessVerification = '8',
  PartnershipVerification = '9',
  LLCVerificiation = '10',
  Reattribution = '11',
  ForeignDonor = '12',
  NonFedVerification = '13'
}

export enum ResponseActions {
  Refund = '1',
  RefundNoResponse = '10',
  Permissible = '2',
  Redesignation = '3',
  Reattribution = '4',
  Attribute = '5',
  AttributeSoleProprietor = '8',
  AttributePartner = '9'
}

export enum AttributedDonorTypes {
  LLC = '8',
  LLP = '9',
  ORG = '13'
}

export interface DonationComplianceTransactionRowVM {
  donationId: number | null;
  splitId: number | null;
  complianceActionTypId?: number | null;
  fundCodeId: number | null;
  amount: number | null;
  refundAmount: number | null; 
  editDate: Date | null;
}
